import { useSuperAuth } from "../../context/SuperAuthContext";
import { ShieldCheck } from "lucide-react";

export default function SuperMyAccount() {
  const { sa } = useSuperAuth();
  if (!sa) return null;
  return (
    <div className="max-w-xl space-y-4" data-testid="super-my-account">
      <h1 className="text-2xl font-semibold">Minha Conta</h1>
      <div className="rounded-2xl border border-zinc-200 bg-white p-6 space-y-3 shadow-sm">
        <div className="flex items-center gap-3">
          <div className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-brand-50 border border-brand-100">
            <ShieldCheck size={16} className="text-brand-500" />
          </div>
          <div>
            <div className="font-medium">{sa.name}</div>
            <div className="text-sm text-zinc-500">{sa.email}</div>
          </div>
        </div>
        <p className="text-xs text-zinc-500">
          Super Admin não pertence a nenhum tenant. Gestão de senha via administrador da plataforma.
        </p>
      </div>
    </div>
  );
}
